import React, { useContext, useEffect, useState } from "react";
import { auth } from "../../api/config";
// constants
import { APP_BUNDLES } from "../../../app_constant";
import { USER_DEAFULT_KEY } from "../../constant/event";
import { ThemeContext } from "../../context/ThemeProvider";
import { useNavigate } from "react-router-dom";
import { BundleContext } from "../../context/BundleProvider";
import { ChangeExamModal } from "../common/CommonModals";

const ChangeExam = (props) => {
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const { selectedCertificate, setSelectedBundle } = useContext(BundleContext);
  const selectedItem = props.isFirst ? APP_BUNDLES[0].key : selectedCertificate;

  const [userDetail, setUserDetail] = useState({});
  const [selected, setSelected] = useState(selectedItem);
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [currentStep, setCurrentStep] = useState(0);
  
  const steps = [
    { icon: "faExchangeAlt", text: "Switching exam preparation" },
    { icon: "faCog", text: "Loading new content" },
    { icon: "faBook", text: "Preparing study materials" },
    { icon: "faClipboardList", text: "Setting up practice tests" },
    { icon: "faLayerGroup", text: "Organizing flashcards" },
    { icon: "faRocket", text: "Almost ready!" }
  ];

  const startLoadingAnimation = () => {
    setIsLoading(true);
    setProgress(0);
    setCurrentStep(0);
    
    const stepDuration = 400; // 400ms per step
    const totalDuration = stepDuration * steps.length;
    
    const progressInterval = setInterval(() => {
      setProgress(prev => {
        const newProgress = prev + (100 / steps.length);
        if (newProgress >= 100) {
          clearInterval(progressInterval);
          return 100;
        }
        return newProgress;
      });
    }, stepDuration);

    const stepInterval = setInterval(() => {
      setCurrentStep(prev => {
        if (prev >= steps.length - 1) {
          clearInterval(stepInterval);
          return prev;
        }
        return prev + 1;
      });
    }, stepDuration);

    return () => {
      clearInterval(progressInterval);
      clearInterval(stepInterval);
    };
  };

  const onChangeBundle = async (certificateName) => {
    if (certificateName === selectedCertificate) {
      props.onCancle();
      return;
    }
    if (selected) {
      localStorage.setItem(
        USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS,
        certificateName
      );
      await setSelectedBundle(certificateName);
      props.onPress(certificateName);

      if (props.isFirst) {
        window.location.reload();
      } else {
        // Start loading animation
        startLoadingAnimation();
        
        // Add a delay before navigation to show the loader
        setTimeout(async () => {
          navigate("/prepare", {
            state: {
              firstName: userDetail?.firstName ?? "",
              isFromOnboarding: false,
              isFromLoginSignup: false,
              loginSignupType: userDetail?.loginWay ?? "",
            },
          });
          // Add a small delay before calling onComplete to ensure smooth transition
          setTimeout(() => {
            if (props.onComplete) {
              props.onComplete();
            }
          }, 500);
        }, 2500); // 2.5 seconds delay to show loader
      }
    } else {
      await setSelectedBundle(APP_BUNDLES[0].key);
      props.onCancle();

      setTimeout(async () => {
        window.location.reload();
      }, 1500);
    }
  };

  const handleClose = () => {
    if (!isLoading) {
      setIsModalOpen(false);
      props.onCancle();
    }
    // Don't allow closing when loading
  };

  const handleConfirm = (selectedBundle) => {
    onChangeBundle(selectedBundle);
    localStorage.setItem(
      USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS,
      selectedBundle
    );
    // Don't call handleClose() here - it's handled in onChangeBundle
  };

  const handleBundleSelect = (bundleKey) => {
    setSelected(bundleKey);
  };

  useEffect(() => {
    let authData = {
      id: auth().currentUser?.uid,
      UserName: auth()?.currentUser?.displayName ?? "",
      email: auth().currentUser.email,
      loginWay: auth().currentUser?.providerData[0]?.providerId ?? "",
      last_signin_time: auth().currentUser.metadata?.lastSignInTime ?? "",
    };
    setUserDetail(authData);
  }, []);

  return (
    <ChangeExamModal
      isOpen={isModalOpen}
      onClose={handleClose}
      onConfirm={handleConfirm}
      title={props.title || "Change Certificate"}
      description={props.desc || "Select a different certificate to switch to"}
      bundles={APP_BUNDLES}
      selectedBundle={selected}
      onBundleSelect={handleBundleSelect}
      theme={theme}
      isLoading={isLoading}
      progress={progress}
      currentStep={currentStep}
    />
  );
};

export default ChangeExam;
